import { QRCode } from 'react-qrcode-logo';
import Image from 'next/image';
import useReferralCode from '@/hooks/onboarding/useReferralCode';
export default function MobileReferralQr() {
  const {
    referralData
  } = useReferralCode();
  const referralLink = referralData && referralData.codes?.referral_code ? `https://tradegenius.com/home?code=${referralData?.codes?.referral_code}` : '';
  return <div className='bg-white w-full flex justify-between items-center text-genius-blue px-[4%] py-2' data-sentry-component="MobileReferralQr" data-sentry-source-file="MobileReferralQr.tsx">
      <div>
        <p className='text-[16px] tracking-[-1px]'>Here's my referrral to</p>
        <div className='flex items-center'>
          <Image src='/static/images/flexgainsmark.png' width={100} height={100} alt='Genius Logo' className='w-full h-[24px] mr-6 mt-2' data-sentry-element="Image" data-sentry-source-file="MobileReferralQr.tsx" />
        </div>
      </div>
      <div>
        <QRCode bgColor='#241747' fgColor='#ffffff' size={60} logoImage='/static/images/logo-3d.png' logoHeight={10} qrStyle='squares' logoWidth={10} logoPadding={8} eyeRadius={0} style={{
        borderRadius: 0
      }} removeQrCodeBehindLogo={true} value={referralLink} data-sentry-element="QRCode" data-sentry-source-file="MobileReferralQr.tsx" />
      </div>
    </div>;
}